module.exports = __webpack_public_path__ + "img/barley.5f71d12d.svg";